import {
  Box,
  Flex,
  styled,
  TableCell,
  TableRow,
  Text,
  Chip,
  type TableRowProps,
} from '@shared/components';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

function renderBox(totalBoxes: number) {
  return (
    <>
      {Array.from({ length: totalBoxes }).map((_, index) => (
        <Box
          key={index}
          sx={{
            minWidth: '16px',
            borderRight: (theme) => `1px solid ${theme.palette.grey[300]}`,
          }}
        />
      ))}
    </>
  );
}

export interface ItemSetQuestionDashboardRowQuestion {
  size: number;
  calculate: {
    hardQuestions: number | null;
    mediumQuestions: number | null;
    easyQuestions: number | null;
  };
  nonCalculate: {
    hardQuestions: number | null;
    mediumQuestions: number | null;
    easyQuestions: number | null;
  };
  total: number;
}

interface ItemSetQuestionDashboardRowProps extends TableRowProps {
  question: ItemSetQuestionDashboardRowQuestion;
  totalBoxes?: number;
}

export default function ItemSetQuestionDashboardRow(
  props: Readonly<ItemSetQuestionDashboardRowProps>,
) {
  const { question, totalBoxes = 0, ...restProps } = props;
  const { calculate, nonCalculate } = question;

  return (
    <TableRow
      {...restProps}
      sx={(theme) => ({
        border: 'none',
        ':last-child': {
          borderRight: 'none',
          td: {
            borderBottom: 'none',
          },
        },
        backgroundColor: theme.palette.background.paper,
        ...restProps.sx,
      })}
    >
      <StyledTableCell
        sx={{
          p: (theme) => theme.spacing(0),
          borderBottom: 'none',
        }}
      >
        <Flex
          sx={(theme) => ({
            minHeight: '48px',
            backgroundColor: theme.palette.background.paper,
          })}
        >
          {renderBox(totalBoxes)}
          <Flex
            sx={(theme) => ({
              alignItems: 'center',
              backgroundColor: theme.palette.background.paper,
              flex: 1,
              borderBottom: '1px solid ' + theme.palette.grey[300],
            })}
          >
            <Flex
              sx={(theme) => ({
                flex: 1,
                p: theme.spacing(2, 1),
                gap: theme.spacing(2),
              })}
            >
              <Box sx={{ minWidth: '48px' }}></Box>
              <Text variant='body2Semibold'>รูปแบบข้อสอบ:</Text>
              <Chip
                label={<Text variant='captionSemibold'>Item Set: {question.size}Q</Text>}
                size='small'
                sx={(theme) => ({
                  backgroundColor: theme.palette.info.light,
                  minWidth: '62px',
                })}
              />
            </Flex>
          </Flex>
        </Flex>
      </StyledTableCell>
      <StyledTableCell align='center'>{calculate?.easyQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{calculate?.mediumQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{calculate?.hardQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.easyQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.mediumQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>{nonCalculate?.hardQuestions ?? '-'}</StyledTableCell>
      <StyledTableCell align='center'>
        {question.total}({question.size * question.total})
      </StyledTableCell>
    </TableRow>
  );
}
